import styled from 'styled-components';

/**
 * @type {import('styled-components').StyledComponent<"div", any, { reverse?: boolean }, never>}
 *
 * @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`.
 */
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: ${props => (props.reverse ? 'column-reverse' : 'column')};
`;

/**
 * @type {import('styled-components').StyledComponent<"div", any, {}, never>}
 *
 * @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`.
 */
export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

/**
 * @type {import('styled-components').StyledComponent<"div", any, { direction?: string; }, never>}
 *
 * @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`.
 */
export const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${props => props.direction || 'row'};
`;

/**
 * @type {import('styled-components').StyledComponent<"div", any, { direction?: string; }, never>}
 *
 * @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`.
 */
export const FlexBetween = styled.div`
  display: flex;
  justify-content: space-Between;
  align-items: center;
  flex-direction: ${props => props.direction || 'row'};
`;

/**
 * @type {import('styled-components').StyledComponent<"div", any, { direction?: string; }, never>}
 *
 * @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`.
 */
export const FlexAround = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: ${props => props.direction || 'row'};
`;
